// @flow

import * as React from 'react';
import {Toast, ToastLayer} from 'sail/Toast';
import Icon from 'sail/Icon';

type Props = {
  cardNumber: string,
};
type State = {
  showToast: boolean,
};
export default class CopyableTestCardNumber extends React.Component<
  Props,
  State,
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showToast: false,
    };
  }

  formatCardNumber = () => {
    const cardSegments = this.props.cardNumber.match(/.{1,4}/g);
    if (!cardSegments) {
      return null;
    }

    return (
      <React.Fragment>
        {cardSegments.map((cardSegment, index) => {
          return (
            <React.Fragment key={index}>
              {cardSegment}
              <span />
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  };

  showToast = () => {
    this.setState({showToast: true});
    setTimeout(() => {
      this.setState({showToast: false});
    }, 1000);
  };

  copyToClipboard = () => {
    const el = document.createElement('textarea');
    el.setAttribute('readonly', '');
    // $FlowFixMe Expecting a CSSStyleDeclaration
    el.style = {position: 'absolute', left: '-9999px'};
    el.value = this.props.cardNumber;
    if (document.body) {
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body && document.body.removeChild(el);
    }
    this.showToast();
    if (
      window.siteAnalytics &&
      window.siteAnalytics.trackIntegrationCheckerAction
    ) {
      window.siteAnalytics.trackIntegrationCheckerAction(
        'copy_test_card_number',
        {testCardNumber: this.props.cardNumber},
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <span
          className="card-number integration-checkers-card-number"
          onClick={() => {
            this.copyToClipboard();
          }}
        >
          {this.formatCardNumber()}
          <span style={{height: '16px', width: '16px'}}>
            <Icon hoverable icon="clipboard" color="blue" />
          </span>
        </span>

        {
          <ToastLayer position="bottom">
            {this.state.showToast ? <Toast>Copied!</Toast> : null}
          </ToastLayer>
        }
      </React.Fragment>
    );
  }
}
